import { Search, Filter, MapPin, Truck, ChevronDown, X } from 'lucide-react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

const truckTypes = ['Dry Van', 'Flatbed', 'Reefer', 'Container', 'Power Only'];

export const LoadFilters = ({ filters, setFilters, showFilters, setShowFilters, onSearch, onClear }) => (
  <section className="bg-white border-b border-zinc-200 sticky top-16 lg:top-20 z-40">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
      <form onSubmit={onSearch} className="space-y-4">
        <div className="lg:hidden flex justify-between items-center">
          <button
            type="button"
            onClick={() => setShowFilters(!showFilters)}
            className="flex items-center gap-2 text-zinc-700 font-medium h-11 px-3 -ml-3"
            data-testid="toggle-filters-btn"
          >
            <Filter className="w-5 h-5" />
            Filters
            <ChevronDown className={`w-4 h-4 transition-transform ${showFilters ? 'rotate-180' : ''}`} />
          </button>
          <button
            type="submit"
            className="bg-zinc-900 text-white px-4 py-2.5 h-11 text-sm font-bold uppercase tracking-wide"
            data-testid="search-loads-btn-mobile"
          >
            Search
          </button>
        </div>

        <div className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4 ${showFilters ? 'block' : 'hidden lg:grid'}`}>
          <div className="relative">
            <MapPin className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-zinc-400" />
            <input
              type="text"
              value={filters.origin}
              onChange={(e) => setFilters({ ...filters, origin: e.target.value })}
              placeholder="Origin (City, State)"
              className="w-full pl-10 pr-4 py-3 border border-zinc-300 focus:border-zinc-900 outline-none text-sm"
              data-testid="filter-origin"
            />
          </div>

          <div className="relative">
            <MapPin className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-zinc-400" />
            <input
              type="text"
              value={filters.destination}
              onChange={(e) => setFilters({ ...filters, destination: e.target.value })}
              placeholder="Destination (City, State)"
              className="w-full pl-10 pr-4 py-3 border border-zinc-300 focus:border-zinc-900 outline-none text-sm"
              data-testid="filter-destination"
            />
          </div>

          <Select
            value={filters.truckType || "all"}
            onValueChange={(value) => setFilters({ ...filters, truckType: value === "all" ? "" : value })}
          >
            <SelectTrigger className="h-12 border-zinc-300" data-testid="filter-truck-type">
              <Truck className="w-5 h-5 text-zinc-400 mr-2" />
              <SelectValue placeholder="Equipment Type" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="all">All Types</SelectItem>
              {truckTypes.map((type) => (
                <SelectItem key={type} value={type}>{type}</SelectItem>
              ))}
            </SelectContent>
          </Select>

          <button
            type="button"
            onClick={onClear}
            className="flex items-center justify-center gap-2 text-zinc-600 hover:text-zinc-900 border border-zinc-300 hover:border-zinc-400 py-3 transition-colors"
            data-testid="clear-filters-btn"
          >
            <X className="w-4 h-4" />
            Clear Filters
          </button>

          <button
            type="submit"
            className="hidden lg:flex items-center justify-center gap-2 bg-zinc-900 hover:bg-zinc-800 text-white py-3 font-bold uppercase tracking-wide transition-colors"
            data-testid="search-loads-btn"
          >
            <Search className="w-4 h-4" />
            Search Loads
          </button>
        </div>
      </form>
    </div>
  </section>
);
